import React from 'react';
import Body from '../../components/P2PAds/P2PAdsEdit/Body';

const P2PAdsEditPage = () => {
	return <Body />;
};

export default P2PAdsEditPage;
